<script setup>
import { SelectScrollUpButton, useForwardProps } from "reka-ui";
import { ChevronUp } from "lucide-vue-next";
import { cn } from "@/shared/lib/utils";
import { reactiveOmit } from "@vueuse/core";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
});

const delegatedProps = reactiveOmit(props, "class");
const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <SelectScrollUpButton
    data-slot="select-scroll-up-button"
    v-bind="forwardedProps"
    :class="
      cn('flex cursor-default items-center justify-center py-1', props.class)
    "
  >
    <slot>
      <ChevronUp class="size-4" />
    </slot>
  </SelectScrollUpButton>
</template>
